
/**
 * Mixin contendo todo o comportamento do para uso de Dialogs
 *
 * Uso:
 *  Adicionar aos arrays de Mixins ex: mixins: [ DialogMixin ]
 *
 *  Adicionar ao template a estrutura
 *
 *  <v-dialog v-model="controlDialogVisible" :fullscreen="fullscreen"
 *    :max-width="width" :persistent="!closeWithMask">
 *
 *    o template do dialog deve ser colocado aqui
 *
 *  </v-dialog>
 *
 * Para abrir o Dialog é necessário utilizar o serviço $dialog, ex:
 *
 * this.$dialog.component(UserDialog, {
        width: 800,
        props1: 'conteudo da props 1'
        props2: 'conteudo da props 2' }).then((response) => {
          call back executado quando o modal é fechado
          response.data
          response.action
        });
 *
 * Para o fechar o Dialog e passar informações para quem chamou basta emitir um evento close, ex:
 *
 *  this.$emit('close', params);
 *    ou
 *  this.sendParamsOnClose(params);
 *
 * Por padrão os eventos (esc, clicar na mascara do Dialog) do Dialog
 * chamam sendParamsOnClose quando o mesmo é fechado.
 */
export default {
  model: {
    prop: 'visible',
    event: 'visibleChange',
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    width: {
      type: [Number, String],
      default: 520,
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    closeWithMask: {
      type: Boolean,
      default: true,
    },
    closeWithEsc: {
      type: Boolean,
      default: true,
    },
    throughService: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      controlDialogVisible: this.visible,
    };
  },
  watch: {
    /**
     * Metodo que atualiza o controle do modal de acordo com as mudanças no v-model do pai
     * @param {*} newValue
     */
    visible(newValue) {
      this.controlDialogVisible = newValue;
    },

    /**
     * Metodo que controla a visibilidade do dialog.
     * @param {*} newValue
     */
    controlDialogVisible(newValue) {
      if (newValue === false) {
        this.closeDialog();
      }
      // emite esse evento para o v-model do parent quando o dialog é utilizado inline
      this.$emit('visibleChange', newValue);
    },
  },
  methods: {
    /**
     * Metodo responsavel por exibir dialog
     */
    showDialog() {
      this.controlDialogVisible = true;
    },
    /**
     * Metodo responsavel por fechar dialog.
     * @param {*} action
     * @param {*} data
     */
    closeDialog(action, data) {
      this.controlDialogVisible = false;
      this.sendParamsOnClose({ action, data });

      if (this.throughService) {
        this.$destroy(true);
        this.$el.parentNode.removeChild(this.$el);
      }
    },
    /**
     * Metodo responsavel por emitir o evento de close do dialog.
     * @param {*} params
     */
    sendParamsOnClose(params) {
      this.$emit('close', params);
    },
    /**
     * Metodo responsavel por capturar o evento do teclado.
     * @param {*} evt
     */
    handleModalKeyCode(evt) {
      // Escape
      if (this.controlDialogVisible && this.closeWithEsc &&
        evt.keyCode === 27) {
        this.closeDialog('esc');
      }
    },
  },
  mounted() {
    document.addEventListener('keydown', this.handleModalKeyCode);
  },
  beforeDestory() {
    document.removeEventListener('keydown', this.handleModalKeyCode);
  },
};



// WEBPACK FOOTER //
// ./src/components/mixins/DialogMixin.js